import { useState } from "react";
import { Card } from "../Card";
import { ProductChart } from "../ProductChart";
import { Details } from "../Details";
import styles from "./styles.module.scss";

export const VariantsList = ({ data }) => {
  const [variantDetailsState, setVariantDetailsState] = useState({});
  const [activeIndices, setActiveIndices] = useState({});

  const toggleVariantDetails = (asin) => {
    setVariantDetailsState((prevState) => ({
      ...prevState,
      [asin]: !prevState[asin],
    }));
  };

  const setActiveIndexForVariant = (asin, index) => {
    setActiveIndices((prevState) => ({
      ...prevState,
      [asin]: index,
    }));
  };

  return (
    <div className={styles.productsList}>
      {data.data.map((item) => (
        <div className={styles.productWrapper} key={item.asin}>
          {item.variants &&
            item.variants.map((variant) => {
              const isVariantDetails =
                variantDetailsState[variant.asin] || false;
              const activeIndex = activeIndices[variant.asin] || 0;

              return (
                <div className={styles.product} key={variant.asin}>
                  <div className={styles.inner}>
                    <div className={styles.cardWrapper}>
                      <Card
                        title={variant.title}
                        asin={variant.asin}
                        variations={variant.variations}
                        img={variant.img}
                        rating={variant.rating}
                        value={variant.value}
                        status={variant.status}
                        isVariant={true}
                        isDetails={isVariantDetails}
                        setIsDetails={() => toggleVariantDetails(variant.asin)}
                      />
                    </div>

                    <div className={styles.variantChart}>
                      <ProductChart />
                    </div>
                  </div>

                  {isVariantDetails && (
                    <Details
                      activeIndex={activeIndex}
                      setActiveIndex={(index) =>
                        setActiveIndexForVariant(variant.asin, index)
                      }
                    />
                  )}
                </div>
              );
            })}
        </div>
      ))}
    </div>
  );
};
